<template>
  <popup :opened="dataToShow !== ''" @close="changeToShow('')">
    <!-- BEGIN message to confirm delete a beneficiary on referent -->
    <div
      v-if="dataToShow == 'areYouSure'"
      class="mx-5 xl:mx-16 2xl:mx-20 my-8 w-auto h-auto"
    >
      <h3 class="mb-10 text-pink-600">Confirmation de suppression</h3>

      <h6 class="text-indigo-600 mb-10">
        Êtes vous sûr de vouloir révoquer les droits du référent sur le Neopass
        de {{ beneficiaryReferentToEdit.firstname }}
        <span class="uppercase">{{ beneficiaryReferentToEdit.lastname }}</span>
        ? <br />
        Cette suppression sera définitive et irrévocable.
      </h6>

      <div class="w-full flex justify-center">
        <div class="mr-5">
          <action-button
            class="relative flex flex-row"
            border-color="border-pink-600"
            text-color="text-pink-600"
            bg-color="bg-pink-300"
            libelle="ANNULER"
            @clickAction="changeToShow('')"
          />
        </div>
        <div class="w-auto">
          <action-button
            class="relative flex flex-row"
            border-color="border-transparent"
            text-color="text-white"
            bg-color="bg-pink-600"
            libelle="SUPPRIMER"
            type-shadow="shadow-pink"
            @clickAction="confirmDeleteBeneficiaryReferent()"
          />
        </div>
      </div>
    </div>
    <!-- END message to confirm delete a beneficiary on referent -->
    <!-- BEGIN message to confirm the suppression of the beneficiary on referent -->
    <div
      v-if="dataToShow == 'detachSuccess'"
      class="mx-5 xl:mx-16 2xl:mx-20 my-8 w-auto h-auto"
    >
      <h3 class="text-indigo-600 mb-10">
        Le référent {{ referentToEdit.firstname }}
        <span class="uppercase">{{ referentToEdit.lastname }}</span> ne peut
        plus gérer le carnet de parcours du bénéficiaire
        {{ beneficiaryReferentToEdit.firstname }}
        <span class="uppercase">{{ beneficiaryReferentToEdit.lastname }}</span>
      </h3>

      <div class="w-full flex justify-center">
        <illustration name="basket" class="w-full" />
      </div>
    </div>
    <!-- END message to confirm the suppression of the beneficiary on referent -->
  </popup>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex';
import Popup from './../../../components/Popup';
import Illustration from './../../../components/Illustration';
import ActionButton from './../../../components/ActionButton';

export default {
  name: 'DeleteBeneficiaryReferentPopup',

  props: {
    dataToShow: String,
  },

  data() {
    return {};
  },

  components: {
    Popup,
    ActionButton,
    Illustration,
  },

  computed: {
    ...mapGetters({
      saving: 'permissions/saving',
      beneficiaryReferentToEdit:
        'beneficiariesReferent/beneficiaryReferentToEdit',
      referentToEdit: 'referents/referentToEdit',
    }),
  },

  methods: {
    ...mapActions({
      deleteRightsToBeneficiary:
        'beneficiariesReferent/deleteRightsToBeneficiary',
    }),

    ...mapMutations({
      SET_SAVING: 'permissions/SET_SAVING',
    }),

    changeToShow(val) {
      this.$emit('showChange', val);
    },

    confirmDeleteBeneficiaryReferent() {
      this.deleteRightsToBeneficiary()
        .then((r) => {
          this.changeToShow('detachSuccess');
        })
        .catch((error) => {
          console.log('ERRRR:: ', error.response);
          this.changeToShow(100);
        });
    },
  },
};
</script>
